/**
 * 404 Not Found 페이지 (soft-404 방지).
 *
 * - SSR: useSsrStatus 컨텍스트에 404 를 세팅해 server.ts 가 HTTP 404 로 응답
 * - SEO: noindex + 명시적 title
 * - 시설 상세/지역 랜딩에서 title/description 을 바꿔 재사용한다
 */
import { Link } from 'react-router-dom'
import { Search, Home } from 'lucide-react'
import SEO from '@/components/common/SEO'
import { useSsrStatus } from '@/hooks/useSsrStatus'

interface NotFoundPageProps {
  /** 헤딩 겸 SEO title ("| 케어밸런스" 접미사는 SEO 컴포넌트가 부여) */
  title?: string
  description?: string
}

export default function NotFoundPage({
  title = '페이지를 찾을 수 없습니다',
  description = '주소가 잘못 입력되었거나, 삭제되어 더 이상 존재하지 않는 페이지입니다.',
}: NotFoundPageProps) {
  // SSR 응답 상태코드 404 전파 (클라이언트에서는 null → no-op)
  const ssrStatus = useSsrStatus()
  if (ssrStatus) {
    ssrStatus.status = 404
  }

  return (
    <>
      <SEO title={title} noindex />
      <main className="flex min-h-[60vh] flex-1 flex-col items-center justify-center gap-3 bg-cb-gray-50 px-6 py-20 text-center">
        <p className="text-5xl font-extrabold text-cb-gray-300">404</p>
        <h1 className="text-xl font-bold text-cb-gray-900">{title}</h1>
        <p className="text-sm text-cb-gray-500">{description}</p>
        <div className="mt-3 flex flex-wrap justify-center gap-2">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 rounded-xl bg-cb-primary px-5 py-2.5 text-sm font-bold text-white hover:opacity-90"
          >
            <Home size={15} />
            홈으로 이동
          </Link>
          <Link
            to="/facilities"
            className="inline-flex items-center gap-1.5 rounded-xl border border-cb-gray-200 bg-white px-5 py-2.5 text-sm font-semibold text-cb-gray-700 hover:bg-cb-gray-50"
          >
            <Search size={15} />
            시설 검색
          </Link>
        </div>
      </main>
    </>
  )
}
